import { render, staticRenderFns } from "./TechChecker.vue?vue&type=template&id=6f96ff07&scoped=true&"
import script from "./TechChecker.vue?vue&type=script&lang=ts&"
export * from "./TechChecker.vue?vue&type=script&lang=ts&"
import style0 from "./TechChecker.vue?vue&type=style&index=0&id=6f96ff07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96ff07",
  null
  
)

export default component.exports